import { Button } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useFullRoutes } from '~/hooks';
import PriceSection from '~valuation/pages/MyValuations/PriceSection';
import PropertyDetailsSection from '~valuation/pages/MyValuations/PropertyDetailsSection';
import ValuationUpdatedDate from '~valuation/pages/MyValuations/ValuationUpdatedDate';
import ValuationItemLoader from '~valuation/pages/MyValuations/ValuationItemLoader';
import { ValuationItemType } from '~/types/valuationTypes';

export default function EstimationsList({
  estimations,
  isFetching,
}: {
  estimations: ValuationItemType[];
  isFetching?: boolean;
}) {
  const { t } = useTranslation('app');
  const { VALUATION_URL } = useFullRoutes();
  const navigate = useNavigate();

  if (isFetching) {
    return (
      <div className="flex flex-col gap-3x">
        {Array(2)
          .fill(0)
          .map((_, i) => (
            <ValuationItemLoader key={i} />
          ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3x">
      {estimations.map((estimation) => (
        <div
          key={estimation.id}
          className="tab-content-item md:flex-row cursor-pointer"
          role="button"
          onClick={() => navigate(VALUATION_URL.RESULTS(estimation.id))}
        >
          <div className="flex flex-1 flex-col gap-1.5x md:gap-2x ">
            <ValuationUpdatedDate
              date={estimation.updatedAt}
              className="md:hidden"
            />
            <PropertyDetailsSection
              location={estimation.location.titleShortPath}
              propertyType={estimation.propertyType.titleSingular}
            />
            <PriceSection
              price={
                estimation.area
                  ? Number(estimation.currentValuation?.valuationPrice) /
                    estimation.area
                  : undefined
              }
              labelKey="averagePricePerMeter"
            />
          </div>

          <div className="flex w-full items-center justify-between gap-2x md:w-auto md:flex-col md:items-end h-auto">
            <ValuationUpdatedDate
              date={estimation.updatedAt}
              className="hidden md:inline-block"
            />
            <Button
              variant="secondary"
              size="medium"
              onClick={() => navigate(VALUATION_URL.RESULTS(estimation.id))}
              className="w-full md:w-auto"
            >
              {t('moreDetails')}
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
